<template>
  <div
    class="bb-proforma-wrapper"
    @mouseleave="hideExtraEdit()"
  >
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-proforma"
         ref="bbProforma"
         :class="[
            {'bb-proforma_hide': proformaInvoiceSave},
            `bb-proforma_type${invoiceType}`
         ]"
    >
      <div class="bb-proforma-header">
        <div class="bb-proforma-header-title-wrapper">
          <img class="bb-proforma-header-title-wrapper__logo"
               :src="company.image ? company.image.path : defaultLogo">
          <h1
            class="bb-proforma-header-title-wrapper__title"
            :class="`bb-proforma-header-title-wrapper__title_type${invoiceType}`"
          >
            PROFORMA
            <span
              class="bb-proforma__header-invoice"
              :class="`bb-proforma__header-invoice_type${invoiceType}`"
            >
              INVOICE
              <span>*</span>
            </span>
          </h1>
        </div>
        <div
          v-if="currentCompany.isTaxInvoice"
          class="bb-proforma-header__note"
        >
          <span class="bb-proforma__text-accent">*</span>
          This is not a tax invoice. Tax
          <span class="bb-proforma__space_min">
            invoice shall be issued immediately upon receipt of funds.
          </span>
        </div>
      </div>
      <div class="bb-proforma-details">
        <div class="bb-proforma-details-section">
          <div
            class="bb-proforma-details-section__header bb-proforma-details-section__header_first"
            :class="`bb-proforma-details-section__header_type${invoiceType}`"
          >
            DETAILS
          </div>
          <div class="bb-proforma-details-section-item bb-proforma-details-section-item_ref">
            <div class="bb-proforma-details-section-item__title">
              <span>Issued to:</span>
            </div>
            <div class="bb-proforma-details-section-item-client-info" v-click-outside="issuedOpenEdit">
              <div :contenteditable="issuedToEditable"
                   @input="onInputIssued"
                   v-autofocus
                   :class="{'bb-proforma-details-section-item-client-info__name_border': issuedToEditable}"
                   class="bb-proforma-details-section-item-client-info__name"
              >
                <pre>{{issuedTo}}</pre>
              </div>
              <img src="@/assets/images/icon-pencil.png"
                   @click.stop="issuedOpenEdit(true)"
                   class="bb-proforma-details-section-item-client-info__edit"/>
            </div>
          </div>
          <div class="bb-proforma-details-section-item" v-if="checkedCategory.length !== 0">
            <div class="bb-proforma-details-section-item__title">
              Description:
            </div>
            <div>
              {{checkedCategory.join(`${space}and${space}`)}}
            </div>
          </div>
        </div>
        <div class="bb-proforma-details-section">
          <div
            class="bb-proforma-details-section__header bb-proforma-details-section__header_last"
            :class="`bb-proforma-details-section__header_type${invoiceType}`"
          >
            PROFORMA
            <span class="bb-proforma-details-section__header-invoice">INVOICE</span>
          </div>
          <div class="bb-proforma-details-section-item bb-proforma-details-section-item_ref">
            <div class="bb-proforma-details-section-item__title">
              REF:
            </div>
            <template v-if="editableInvoice">
              {{editableInvoice.invoice.number}}
            </template>
            <template v-else>
              <div v-if="clientInfo.invoiceCounter">
                {{generateInvoiceCode()}}
              </div>
            </template>
          </div>
          <div class="bb-proforma-details-section_date">
            <div class="bb-proforma-details-section-item">
              <div class="bb-proforma-details-section-item__title bb-proforma-details-section-item__title_center">
                Issue Date:
              </div>
              <DataPicker @setDate="setIssueDate"
                          :value="dates.issue"
                          :styles="invoiceType !== 2 ? 'proforma' : undefined"
                          :class="{'bb-proforma-details-section-item_event': viewMode}"
                          :hide-ico="proformaInvoiceSave"/>
            </div>
            <div class="bb-proforma-details-section-item">
              <div class="bb-proforma-details-section-item__title bb-proforma-details-section-item__title_center">
                Due Date:
              </div>
              <DataPicker @setDate="setDueDate"
                          :value="dates.due"
                          :default-date="dates.due"
                          :styles="invoiceType !== 2 ? 'proforma' : undefined"
                          :class="{'bb-proforma-details-section-item_event': viewMode}"
                          :hide-ico="proformaInvoiceSave"/>
            </div>
          </div>
        </div>
      </div>
      <div class="bb-proforma-service-list">
        <div class="bb-proforma-service-list-row bb-proforma-service-list-row_header"
             :class="[
               {
                'bb-proforma-service-list-row_pdf': hideForPdf,
                'bb-proforma-service-list-row_pdf-without-discount': hideForPdf && !showDiscount,
                'bb-proforma-service-list-row_without-discount': issueProforma
                },
                `bb-proforma-service-list-row_type${invoiceType}`
             ]"
        >
          <div>#</div>
          <div>
            SERVICE
            <span class="bb-proforma__space">
              DESCRIPTION
            </span>
          </div>
          <div v-if="!hideForPdf"><!-- edit extra --></div>
          <div class="bb-proforma-service-list-row__center">PRICE, AED</div>
          <div class="bb-proforma-service-list-row__center">QTY.</div>
          <div class="bb-proforma-service-list-row__center"
               :class="{'bb-proforma-service-list-row__center_hide': (hideForPdf && !showDiscount) || issueProforma}"
          >
            DISCOUNT
          </div>
          <div class="bb-proforma-service-list-row__center">AMOUNT, AED</div>
          <div class="bb-proforma-service-list-row__center">VAT RATE</div>
          <div class="bb-proforma-service-list-row__center">VAT AMOUNT</div>
          <div class="bb-proforma-service-list-row__center">TOTAL, AED</div>
          <div v-if="!hideForPdf"><!-- toolbar --></div>
        </div>
        <div class="bb-proforma-service-list-row"
             :class="{
        'bb-proforma-service-list-row_pdf': hideForPdf,
        'bb-proforma-service-list-row_without-discount': issueProforma,
        'bb-proforma-service-list-row_pdf-without-discount': hideForPdf && !showDiscount,
        'bb-proforma-service-list-row_expire': service.expireCategory && !hideForPdf && !disableUpdateService(service)
             }"
             v-for="(service,index) in servicesChecked" :key="service.id">
          <!-- index -->
          <div class="bb-proforma-service-list-row__index">
            {{index + 1}}.
          </div>
          <!-- service name -->
          <div class="bb-proforma-service-list-row__name">
            {{getNameCategory(service, service.category)}}
            re.
            <template v-if="editableInvoice || issueProforma">
              {{service.name}}
            </template>
            <template v-else>
              {{service.institution ? service.institution.name : ''}}
              {{service.project ? service.project.name : ''}}
            </template>
          </div>
          <!-- extra edit -->
          <div class="bb-proforma-service-list-row__center" v-if="!hideForPdf">
            <i class="icon-edit bb-icon bb-icon_accent bb-proforma-service-list-row__extra-icon"
               v-if="service.serviceType === 1 && !hideForPdf"
               @click.stop="extraValueEdit = service.id"/>
          </div>
          <!-- price -->
          <div class="bb-proforma-service-list-row__center bb-proforma-service-list-row__amount">
            <div v-if="extraValueEdit !== service.id">{{convertNumber(amount(service).amount)}}</div>
            <div v-else v-click-outside="hideExtraEdit" class="bb-proforma-service-list-row-extra">
              <div class="bb-proforma-service-list-row-extra-item">
                <p class="bb-proforma-service-list-row-extra-item__title">value</p>
                <input class="bb-proforma-service-list-row__input" @click.stop
                       @input="calcValuesService(service, 'value')"
                       v-model="service.value">
              </div>
              <div class="bb-proforma-service-list-row-extra-item">
                <p class="bb-proforma-service-list-row-extra-item__title">extra</p>
                <input class="bb-proforma-service-list-row__input" @click.stop
                       @input="calcValuesService(service, 'extra')"
                       v-model="service.extraValue">
              </div>
            </div>
          </div>
          <!-- qty -->
          <div v-if="!issueProforma" class="bb-proforma-service-list-row__center">
            <input v-if="!hideForPdf && !service.isShortfall && !service.isCreditNote"
                   class="bb-proforma-service-list-row__input
                          bb-proforma-service-list-row__input_center"
                   v-model="service.quantity"
                   :disabled="disableUpdateService(service) || hideForPdf"
                   @input="changeQuantity(service)">
            <span v-else>{{service.quantity}}</span>
          </div>
          <div v-else class="bb-proforma-service-list-row__center">1</div>
          <!-- discount -->
          <div class="bb-proforma-service-list-row-discount" v-if="!hideForPdf && !issueProforma">
            <toggle @toggleChange="toggleChange"
                    :name="service"
                    v-if="!disableUpdateService(service)"
                    :value="discount.status[service.id]"/>
            <input class="bb-proforma-service-list-row__input bb-proforma-service-list-row__input_center"
                   v-autofocus
                   @input="checkDiscount(service.id)"
                   v-if="discount.status[service.id]"
                   v-model.number="discount.number[service.id]">
            <i v-if="discount.status[service.id]"
               class="icon-percent bb-proforma-service-list-row-discount__icon"/>
          </div>
          <div v-else-if="showDiscount"
               class="bb-proforma-service-list-row__center">
            <span>
              {{ discount.number[service.id] ? `${discount.number[service.id]} %` : `-`}}
            </span>
          </div>
          <!-- amount -->
          <div class="bb-proforma-service-list-row__center">
            {{convertNumber(amount(service).total)}}
          </div>
          <!-- vat rate -->
          <div class="bb-proforma-service-list-row__center">
            {{service.vat}}
          </div>
          <!-- vat amount -->
          <div class="bb-proforma-service-list-row__center">
            {{convertNumber(amount(service).vatAmount)}}
          </div>
          <!-- total -->
          <div class="bb-proforma-service-list-row__center">
            {{convertNumber(amount(service).allTotal)}}
          </div>
          <!-- toolbar -->
          <div v-if="!hideForPdf && !service.isShortfall && !service.isCreditNote">
            <Toolbar :delete-index="deleteConfirmIndex"
                     :index="index"
                     :item="service"
                     :no-edit="true"
                     :no-delete="disableUpdateService(service)"
                     @deleteOpen="deleteConfirmIndex = index"
                     @deleteClose=" deleteConfirmIndex = false"
                     @deleteItem="deleteService(index, service.id)"/>
          </div>
          <!-- expire company -->
          <div class="bb-proforma-service-list-row-expire-container" v-if="!disableUpdateService(service)">
            <div class="bb-proforma-service-list-row-expire bb-proforma-service-list-row-expire_include"
                 @click="changeIncludeInProjects(service)"
                 v-if="!hideForPdf && service.serviceType === 2">
              <div class="bb-proforma-service-list-row-expire__label
                          bb-proforma-service-list-row-expire__label_include">
                Include in list of projects
              </div>
              <checkbox class="bb-proforma-service-list-row-expire__checkbox"
                        v-if="!hideForPdf"
                        :name="service.id"
                        :section="service"
                        :value="getIncludeInProjects(service)"
                        :styles="invoiceType !== 2 ? 'red' : undefined"
              />
            </div>
            <div class="bb-proforma-service-list-row-expire"
                 v-if="service.expireCategory && !hideForPdf && service.displaySelectCompany">
              <div class="bb-proforma-service-list-row-expire__label">
                Company
              </div>
              <custom-select :list="clientCompanies"
                             :item="service"
                             :styles="invoiceType !== 2 ? 'red' : undefined"
                             :default-val="service.defaultCompany"
                             @setValue="setClientCompany"/>
            </div>
            <div class="bb-proforma-service-list-row-expire"
                 v-if="service.expireCategory && !hideForPdf && service.displaySelectLicense">
              <div
                class="bb-proforma-service-list-row-expire__label">
                {{getLabelExpireSelect(service.expireCategory)}}
              </div>
              <custom-select v-if="service.licenseList && service.licenseList.length > 0"
                             :list="service.licenseList"
                             :item="service"
                             :styles="invoiceType !== 2 ? 'red' : undefined"
                             :default-val="service.defaultLicense"
                             @setValue="setClientLicense"/>
              <span class="bb-proforma-service-list-row-expire__no-entries"
                    v-else-if="!service.licenseList || service.licenseList.length === 0">
                no entries
              </span>
            </div>
          </div>
        </div>
      </div>
      <button
        class="bb-proforma__button"
        :class="`bb-proforma__button_type${invoiceType}`"
        v-if="!issueProforma"
        @click.stop="addService()"
      >
        <i class="icon-cross"/>Add service
      </button>
      <transition name="fade">
        <ModalWindow @close="hideServicesList" v-if="servicesListOpen">
          <div class="bb-proforma-wrapper-service-table">
            <ServicesList :settings="company.settings"
                          checkList="true"
                          :checked-list="servicesChecked"
                          @addServices="addServices"
                          ref="ServicesList"/>
          </div>
          <template v-slot:buttons>
            <button class="bb-proforma-wrapper-service-table__button bb-button"
                    @click.stop="addServicesCheckList">
              ADD
            </button>
          </template>
        </ModalWindow>
      </transition>
      <div class="bb-proforma-total">
        <div
          class="bb-proforma-total-terms"
          :class="`bb-proforma-total-terms_type${invoiceType}`"
        >
          <div class="bb-proforma-total-terms__title">
            TERMS
            <span class="bb-proforma__space_min">&</span>
            CONDITIONS
          </div>
          <span>{{conditionsText}}</span>
          <span class="bb-proforma__text-accent">{{texts.conditions.accent}}</span>
        </div>
        <div class="bb-proforma-total-calculations">
          <div class="bb-proforma-total-calculations__row">
            <span>
              SUBTOTAL
              <span class="bb-proforma__space">(EXCL. VAT):</span>
            </span>
            <span>{{convertNumber(subTotal())}}</span>
          </div>
          <div class="bb-proforma-total-calculations__row">
            <span>VAT:</span>
            <span>{{convertNumber(totalVat())}}</span>
          </div>
          <div class="bb-proforma-total-calculations__row
                      bb-proforma-total-calculations__row_available"
               v-if="clientTotals.status === 'overpaid' && !hideForPdf"
          >
            <span>! CHECK OVERPAYMENTS</span>
            <span>AED {{convertNumber(clientTotals.overpaid)}}</span>
          </div>
          <div v-if="clientTotals.status === 'overpaid' && !hideForPdf"
               class="bb-proforma-total-calculations__row
                      bb-proforma-total-calculations__row_additional
                      bb-proforma-total-calculations__row_total"
               :class="['bb-proforma-total-calculations__row_' + clientTotals.status]"
               v-for="(overPayment, index) in clientTotals.overpaidInvoices"
               :key="index"
          >
            <span class="bb-proforma-total-calculations__row__applied">Inv. {{overPayment.invoiceNumber}}</span>
            <span class="bb-proforma-total-calculations__row__applied">AED {{convertNumber(overPayment.value)}}</span>
          </div>
          <transition name="fade">
            <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_additional
                        bb-proforma-total-calculations__row_total bb-proforma-total-calculations__row_underpaid"
                 v-if="displayAdditionalPay()"
                 :class="[
                            {'bb-proforma-total-calculations__row_hide': !addAdditionalPay}
                          ]">
              <span class="bb-proforma-total-calculations__row__applied">
                <checkbox class="bb-proforma-bank-details-checkboxes__checkbox
                                 bb-proforma-bank-details-checkboxes__checkbox_payments"
                          v-if="!hideForPdf && !viewMode"
                          @checkboxChange="checkboxChangeAdditionalPay"
                          :value="addAdditionalPay"
                          :styles="invoiceType !== 2 ? 'red' : undefined"
                />
                          PREVIOUS DUES
              </span>
              <template v-if="addAdditionalPay">
                <div class="bb-proforma-total-calculations__row__applied">
                  <template v-if="!hideForPdf">
                    <div class="bb-proforma-total-calculations-dues">
                      <span class="bb-proforma-total-calculations-dues__right">AED</span>
                      <span>{{additionalPay}}</span>
                    </div>
                  </template>
                  <template v-else>
                    <span>AED {{convertNumber(additionalPay)}}</span>
                  </template>
                </div>
              </template>
            </div>
          </transition>
          <transition name="fade">
            <div class="bb-proforma-total-calculations__row
                        bb-proforma-total-calculations__row_available
                        bb-proforma-total-calculations__row_total"
                 :class="{'bb-proforma-total-calculations__row_hide': true}"
                 v-if="clientInfo.selectServices && totalCreditNotes > 0"
            >
              <span>CREDITS AVAILABLE AED</span>
              <span>{{convertNumber(totalCreditNotes)}}</span>
            </div>
          </transition>
          <div class="bb-proforma-total-calculations__totals">
            <transition name="fade">
              <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_accent
                          bb-proforma-total-calculations__row_total"
                   v-if="clientInfo.selectServices">
                <span>TOTAL</span>
                <span>
                  AED {{addAdditionalPay || includeCreditNotes
                  ? convertNumber(payment().toBePay)
                  : convertNumber(payment().AED)}}
                </span>
              </div>
            </transition>
            <transition name="fade">
              <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_accent
                          bb-proforma-total-calculations__row_total"
                   v-if="editableInvoice"
              >
                <span>PAYMENT</span>
                <span>AED {{convertNumber(editableInvoice.invoice.payments)}}</span>
              </div>
            </transition>
            <transition name="fade">
              <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_accent
                          bb-proforma-total-calculations__row_total"
                   v-if="editableInvoice"
              >
                <span>CREDITS APPLIED</span>
                <span>AED {{convertNumber(editableInvoice.invoice.creditNotes)}}</span>
              </div>
            </transition>
            <transition name="fade">
              <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_accent
                          bb-proforma-total-calculations__row_total"
                   v-if="clientInfo.selectServices">
                <span>
                  TOTAL
                  <span class="bb-proforma__space_min">DUE:</span>
                </span>
                <span>
                  AED {{convertNumber(totalDue())}}
                </span>
              </div>
            </transition>

            <transition name="fade">
              <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_total"
                   v-if="bankDetailValue.USD">
                <span>or</span>
              </div>
            </transition>
            <transition name="fade">
              <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_accent
                          bb-proforma-total-calculations__row_total"
                   v-if="bankDetailValue.USD">
                <span>TOTAL IN USD</span>
                <span>USD {{convertNumber(payment().USD)}}</span>
              </div>
            </transition>
            <transition name="fade">
              <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_total"
                   v-if="bankDetailValue.EUR">
                <span>or</span>
              </div>
            </transition>
            <transition name="fade">
              <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_accent
                          bb-proforma-total-calculations__row_total"
                   v-if="bankDetailValue.EUR">
                <span>TOTAL IN EURO</span>
                <span>EURO {{convertNumber(payment().EUR)}}</span>
              </div>
            </transition>
            <transition name="fade">
              <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_total"
                   v-if="bankDetailValue.RUB">
                <span>or</span>
              </div>
            </transition>
            <transition name="fade">
              <div class="bb-proforma-total-calculations__row bb-proforma-total-calculations__row_accent
                          bb-proforma-total-calculations__row_total"
                   v-if="bankDetailValue.RUB">
                <span>TOTAL IN RUB</span>
                <span>RUB {{convertNumber(payment().RUB)}}</span>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="bb-proforma-bank">
        <div class="bb-proforma-bank-name bb-proforma__text-accent">
          <div>Please mention the following payment reference:</div>
          <span class="bb-proforma-bank-name__reference" v-if="clientInfo.invoiceCounter">
            <span v-if="invoiceId">REF</span>
            <template v-if="editableInvoice">
              {{editableInvoice.invoice.number}}
            </template>
            <template v-else>
              {{generateInvoiceCode()}}
            </template>
             {{checkedCategory.join(' and ')}}
        </span>
        </div>
        <div class="bb-proforma-bank-details">
          <div class="bb-proforma-bank-details__title">
            Bank Account Payment Details
          </div>
          <div
            class="bb-proforma-bank-details__select"
            :class="`bb-proforma-bank-details__select_type${invoiceType}`"
          >
            <template v-if="editableInvoice">
              <custom-select
                :list="bankDetailsList"
                :styles="invoiceType !== 2 ? 'red' : undefined"
                :default-val="editableInvoice.invoice ? editableInvoice.invoice.bankAccount : false"
                @setValue="setBankDetails"
              />
            </template>
            <template v-else>
              <custom-select
                :list="bankDetailsList"
                :styles="invoiceType !== 2 ? 'red' : undefined"
                @setValue="setBankDetails"
              />
            </template>
          </div>
          <div class="bb-proforma-bank-details-checkboxes" v-if="bankDetailsList.length !== 0">
            <checkbox
              class="bb-proforma-bank-details-checkboxes__checkbox"
              checkboxText="AED"
              name="AED"
              @checkboxChange="checkboxChange"
              :value="bankDetailValue['AED']"
              :styles="invoiceType !== 2 ? 'red' : undefined"
            />
            <transition name="fade-submenu">
              <checkbox
                class="bb-proforma-bank-details-checkboxes__checkbox"
                checkboxText="USD"
                name="USD"
                :value="bankDetailValue['USD']"
                @checkboxChange="checkboxChange"
                :styles="invoiceType !== 2 ? 'red' : undefined"
                v-if="bankDetails.iban ? bankDetails.iban.usd : ''"/>
            </transition>
            <transition name="fade-submenu">
              <checkbox
                class="bb-proforma-bank-details-checkboxes__checkbox"
                checkboxText="EUR"
                name="EUR"
                :value="bankDetailValue['EUR']"
                @checkboxChange="checkboxChange"
                :styles="invoiceType !== 2 ? 'red' : undefined"
                v-if="bankDetails.iban ? bankDetails.iban.eur : ''"/>
            </transition>
            <transition name="fade-submenu">
              <checkbox
                class="bb-proforma-bank-details-checkboxes__checkbox"
                checkboxText="RUB"
                name="RUB"
                :value="bankDetailValue['RUB']"
                @checkboxChange="checkboxChange"
                :styles="invoiceType !== 2 ? 'red' : undefined"
                v-if="bankDetails.iban ? bankDetails.iban.rub : ''"/>
            </transition>
          </div>
        </div>
        <div class="bb-proforma-bank-card" v-if="bankDetailsList.length !== 0">
          <div class="bb-proforma-bank-card__item">
            <pre>{{bankDetails.details}}</pre>
          </div>
          <div class="bb-proforma-bank-card__item bb-proforma-bank-card__item_iban" v-if="bankDetailValue.AED">
            AED Account: {{bankDetails.iban ? bankDetails.iban.aed : ''}}
          </div>
          <div class="bb-proforma-bank-card__item bb-proforma-bank-card__item_iban" v-if="bankDetailValue.USD">
            USD Account: {{bankDetails.iban ? bankDetails.iban.usd : ''}}
          </div>
          <div class="bb-proforma-bank-card__item bb-proforma-bank-card__item_iban" v-if="bankDetailValue.EUR">
            EUR Account: {{bankDetails.iban ? bankDetails.iban.eur : ''}}
          </div>
          <div class="bb-proforma-bank-card__item bb-proforma-bank-card__item_iban" v-if="bankDetailValue.RUB">
            RUB Account: {{bankDetails.iban ? bankDetails.iban.rub : ''}}
          </div>
        </div>
      </div>
      <div class="bb-proforma-footer">
        <div class="bb-proforma-footer__row">
          Thank you for your trust in our services. We value your business.
        </div>
        <div>
          <div
            v-for="item in invoiceDetails"
            :key="item._id"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactsApi from '@/api/Contacts/api'
import CompaniesApi from '@/api/Companies/api'
import bankDetailsApi from '@/api/BankDetails/api'
import InvoiceApi from '@/api/Invoce/api'
import userApi from '@/api/User/api'
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import ServicesList from '@/components/Settings/Services/ServicesList/ServicesList'
import toggle from '@/components/Main/Inputs/toggle'
import Checkbox from '@/components/Main/Inputs/checkbox'
import ButtonsEdit from '@/components/Main/ButtonsEdit/ButtonsEdit'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import '@/assets/fonts/fontsPdf/ArialBold-bold'
import '@/assets/fonts/fontsPdf/ArialRegular-normal'
import convertNumber from '@/mixin/convertNumber'
import _ from 'lodash'
import JsPdf from 'jspdf'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import {contactType} from '@/constants/clientInfo'
import moment from 'moment'
import defaultLogo from '@/assets/images/logo.png'
import ContactCompanyApi from '@/api/ContactCompanies/api'
import ContactsLicenseApi from '@/api/ContactsLicense/api'
import ContactsAddressApi from '@/api/ContactsAddress/api'
import SoaApi from '@/api/Soa/api'
import CreditNotesApi from '@/api/CreditNotes/api'
import SoaCreditNote from '@/api/SoaCreditNote/api'
import {
  expireCategoriesForServiceForm,
  LICENSE_EXPIRY,
  ECHANNEL_EXPIRY,
  CARD_EXPIRY,
  OFFICE_LEASE_EXPIRY,
  APARTMENT_LEASE_EXPIRY,
  VISA_EXPIRY
} from '@/constants/expireCategories'
import ContactCompanyVisasApi from '@/api/ContactVisas/api'
import serviceCategoriesList from '@/mixin/serviceCategoriesList'

export default {
  name: 'ProformaInvoice',
  mixins: [convertNumber, serviceCategoriesList],
  props: ['editableInvoice', 'viewMode', 'issueProformaServices', 'issueProforma', 'invoiceIssueId'],
  components: {
    Checkbox,
    CustomSelect,
    DataPicker,
    ServicesList,
    toggle,
    ButtonsEdit,
    LoaderFly,
    ModalWindow,
    Toolbar
  },
  data: function () {
    return {
      companyLicenses: {},
      clientAddress: {},
      companyVisas: {},
      changeAdditionalPay: false,
      hideForPdf: false,
      additionalPay: 0,
      previousDues: 0,
      currentCreditNotes: 0,
      maxCreditNotes: 0,
      oldAdditionalPay: 0,
      oldClientStatus: '',
      addAdditionalPay: false,
      includeCreditNotes: false,
      totalCreditNotes: 0,
      clientTotals: {
        overpaid: 0,
        underpaid: 0,
        ratio: 0,
        previousDues: 0,
        status: '',
        overpaidInvoices: []
      },
      editBankSet: false,
      servicesDeleted: [],
      defaultLogo: defaultLogo,
      space: String.fromCharCode(160),
      extraValueEdit: false,
      issuedTo: false,
      issuedToEditable: false,
      issuedToChange: false,
      checkboxDisable: false,
      addServicesCheckList: false,
      deleteConfirmIndex: false,
      loaderRun: false,
      proformaInvoiceSave: false,
      contactType: contactType,
      originalInvoice: false,
      newStatus: '',
      discount: {
        status: {},
        number: {}
      },
      category: {},
      bankDetails: {
        iban: {},
        currencyRates: {}
      },
      bankDetailValue: {
        AED: true,
        USD: false,
        EUR: false,
        RUB: false,
      },
      servicesListOpen: false,
      company: {},
      servicesChecked: [],
      dates: {
        issue: new Date(),
        due: this.setSevenDays(new Date())
      },
      texts: {
        conditions: {
          text: 'The amount is payable in full in advance into %company% bank account.',
          accent: 'Dear Customer, kindly be advised that current invoice shall be ' +
            'considered paid only when the full amount is credited. ' +
            'Please, make sure that all related transfer charges are covered by the sender.'
        },
        details: {
          row1: 'Business Boutique DMCC | License No. DMCC-233817 | Office 301 | Fortune Executive Tower',
          row2: 'Jumeirah Lakes Towers | Dubai, UAE | Tel. +971 4 368 4884 | Email: uae@uae-consulting.com',
          row3: 'Business Boutique DMCC is registered and licensed as a freezone company under the rules ' +
            '& regulations of DMCC'
        }
      }
    }
  },
  computed: {
    hideCreditNote () {
      if (this.editableInvoice) {
        return !this.viewMode ? this.maxCreditNotes : this.currentCreditNotes
      } else {
        return this.maxCreditNotes
      }
    },
    clientCompanies: {
      get () {
        return this.$store.getters.clientCompanies
      },
      set (data) {
        this.$store.dispatch('setClientCompanies', data)
      }
    },
    invoiceId () {
      const invoice = _.get(this.editableInvoice, 'invoice', '')
      return _.get(invoice, 'id', '')
    },
    checkedCategory () {
      const categoryArr = []
      _.forEach(this.servicesChecked, item => {
        if (!(_.isNull(item.category))) {
          categoryArr.push(this.getNameCategory(item, item.category))
        }
      })
      return _.uniq(categoryArr)
    },
    showDiscount () {
      const status = Object.values(this.discount.status)
      return status.some(item => item)
    },
    totalServices () {
      return this.servicesChecked.reduce((accumulator, currentValue) => {
        return (accumulator + (+this.amount((currentValue)).total))
      }, 0)
    },
    totalServicesVat () {
      return this.servicesChecked.reduce((accumulator, currentValue) => {
        if (+currentValue.vat < 1 || isNaN(currentValue.vat)) {
          return accumulator
        }
        return (accumulator + (+this.amount((currentValue)).total))
      }, 0)
    },
    invoicesList: {
      get: function () {
        return this.$store.getters.invoicesList
      },
      set: function (data) {
        this.$store.dispatch('setInvoicesList', data)
      }
    },
    clientInfo: {
      get: function () {
        return this.$store.getters.clientInfo
      },
      set: function (data) {
        this.$store.dispatch('setClientInfo', data)
      }
    },
    serviceCategories: {
      get: function () {
        return this.$store.getters.serviceCategories
      },
      set: function (data) {
        this.$store.dispatch('setServiceCategories', data)
      }
    },
    servicesList: {
      get: function () {
        return this.$store.getters.servicesList
      },
      set: function (data) {
        this.$store.dispatch('setServicesList', data)
      }
    },
    activeCompany: function () {
      return this.$store.getters.activeCompany
    },
    bankDetailsList: {
      get: function () {
        return this.$store.getters.bankDetails
      },
      set: function (data) {
        this.$store.dispatch('setBankDetails', data)
      }
    },
    userInfo: {
      get: function () {
        return this.$store.getters.userInfo
      },
      set: function (data) {
        this.$store.dispatch('setUserInfo', data)
      }
    },
    currentCompany () {
      return this.$store.getters.currentCompany
    },
    invoiceType () {
      const { invoiceType = 1 } = this.currentCompany
      return invoiceType
    },
    conditionsText () {
      const { conditions: { text } } = this.texts
      const { invoiceTerms = 'Business Boutique’s' } = this.currentCompany
      return text.replace('%company%', invoiceTerms)
    },
    invoiceDetails () {
      const { invoiceDetails } = this.currentCompany;
      return invoiceDetails
    }
  },
  methods: {
    setFocusAdditionalPay () {
      if (this.additionalPay === 0) {
        this.additionalPay = 0
      }
    },
    setFocusCreditNote () {
      if (this.currentCreditNotes === 0) {
        this.currentCreditNotes = 0
      }
    },
    checkedMaxValueAdditionalPay () {
      this.additionalPay = String(this.additionalPay).replace(/[^0-9|.]+/gmi, '')
      const additionalPay = this.validateNum(this.additionalPay)
      const ratio = this.clientTotals.ratio
      const ratioUnderpaid = ratio
      const isOverpaid = ratio > 0
      const isUnderpaid = ratio < 0
      const totalAed = this.payment().AED - (this.includeCreditNotes ? this.currentCreditNotes : 0)
      const overflow = ratio > totalAed
      if (additionalPay < 0) this.additionalPay = 0
      if (additionalPay >= ratio && isOverpaid) {
        this.additionalPay = ratio
      } else if (additionalPay >= ratioUnderpaid && isUnderpaid) {
        this.additionalPay = this.clientTotals.previousDues
      }
      if (isOverpaid && additionalPay > totalAed && overflow) {
        this.additionalPay = totalAed
      }
    },
    totalDue () {
      const received = _.get(this.editableInvoice, ['invoice', 'received'], 0)
      const result = this.payment().toBePay - received
      return result > 0 ? result : 0
    },
    checkedMaxValueCreditNote () {
      this.currentCreditNotes = String(this.currentCreditNotes).replace(/[^0-9|.]+/gmi, '')
      const creditNotes = this.validateNum(this.currentCreditNotes)
      const currentCreditNotes = this.roundNum(creditNotes)
      const additionalPay = (this.addAdditionalPay ? this.additionalPay : 0)
      const totalAed = this.payment().AED - (this.clientTotals.ratio > 0 ? additionalPay : -1 * additionalPay)
      if (totalAed === 0 || currentCreditNotes < 0) {
        this.currentCreditNotes = 0
      } else if (currentCreditNotes > this.maxCreditNotes) {
        this.currentCreditNotes = this.maxCreditNotes > totalAed ? totalAed : this.maxCreditNotes
      } else if (totalAed < currentCreditNotes) {
        this.currentCreditNotes = currentCreditNotes - (currentCreditNotes - totalAed)
      }
      if (this.isNotConsumed < 0) this.isNotConsumed = 0
    },
    getIncludeInProjects (service) {
      return _.get(service, 'includeOfProject', '')
    },
    changeIncludeInProjects (service) {
      if (this.disableUpdateService(service)) return
      const value = _.get(service, 'includeOfProject', false)
      _.set(service, 'includeOfProject', !value)
      this.servicesChecked = _.cloneDeep(this.servicesChecked)
    },
    disableUpdateService (service) {
      const approved = service.approvedValue > 0 || service.approvedValueBusinessConsultant > 0
      const hasTransfer = _.get(service, 'transfer.length', 0)
      const isCreditNote = _.get(service, 'isCreditNote', false)
      const isShortfall = _.get(service, 'isShortfall', false)
      const expirePaid = service.expireCategory && service.currentValue > 0
      return !!(approved || hasTransfer || expirePaid || isCreditNote || isShortfall)
    },
    activeViewMode () {
      let contentHtml = document.getElementsByClassName('bb-proforma')[0]
      contentHtml.classList.add('bb-proforma')
      contentHtml.classList.add('bb-proforma_hide')
    },
    hideExtraEdit () {
      if (this.issueProforma) return
      this.servicesChecked.forEach((item, index) => {
        item.quantity = item.quantity || 1
        this.$set(this.servicesChecked, index, item)
      })
      this.extraValueEdit = false
    },
    onInputIssued (e) {
      this.issuedToChange = e.target.innerText
    },
    issuedOpenEdit (data) {
      data !== true ? this.issuedToEditable = false : this.issuedToEditable = true
      const div = document.getElementsByClassName('bb-proforma-details-section-item-client-info__name')
      setTimeout(() => {
        if (div[0]) div[0].focus()
      }, 0)
    },
    getNameCategory (service, category) {
      let idCategory = service.serviceType || category
      if (service.serviceType === 0) {
        idCategory = 0
      }
      const res = _.find(this.serviceCategories, item => item.id === idCategory)
      return res ? res.name : ''
    },
    generateInvoiceCode () {
      this.clientInfo.contactType = this.clientInfo.contactType || this.contactType[0].id
      const contactType = _.find(this.contactType, elem => elem.id === +this.clientInfo.contactType)
      const clientCounter = this.clientInfo.clientCounter || 1
      const invoiceCounterHas = this.clientInfo.invoiceCounter.hasOwnProperty('seq')
      const invoiceCounter = invoiceCounterHas ? this.clientInfo.invoiceCounter.seq + 1 : 1
      const { invoicePrefix = 'BB-DMCC' } = this.currentCompany
      const { isDefault } = contactType
      const [invoicePrefixCompany] = invoicePrefix.split('-')
      const prefix = isDefault ? invoicePrefix : `${invoicePrefixCompany}-${contactType.code}`
      return `${prefix}-${clientCounter}-${invoiceCounter}`
    },
    generatePdf (goBack) {
      const { invoice = {} } = this.editableInvoice || {}
      const { number } = invoice
      this.loaderRun = true
      let contentHtml = document.getElementsByClassName('bb-proforma')[0].cloneNode(true);
      let dpi = document.createElement('div')
      dpi.style.width = '1cm'
      dpi.style.height = '1cm'
      dpi.style.position = 'fixed'
      dpi.style.top = '-100%'
      dpi.style.left = '-100%'
      dpi.style.zIndex = '-1'
      document.body.appendChild(dpi)
      const maxHeightA4 = 27 * dpi.clientHeight * 0.8
      contentHtml.style.position = 'fixed'
      contentHtml.style.top = '0'
      contentHtml.style.left = '0'
      contentHtml.style.padding = '1cm'
      contentHtml.style.width = '19cm'
      contentHtml.style.zIndex = -1
      contentHtml.style.transform = 'scale(0.85)'
      contentHtml.style.transformOrigin = 'top center'
      contentHtml.classList.add('bb-proforma')
      contentHtml.classList.add('bb-proforma_hide')
      const fileName = `${number || this.generateInvoiceCode()}.pdf`
      document.body.appendChild(contentHtml)
      let i = 85
      if (contentHtml.clientHeight > maxHeightA4) {
        while (i > 2 && (contentHtml.clientHeight * (i * 0.01)) > maxHeightA4) {
          contentHtml.style.transform = `scale(0.${i})`
          i--
        }
      }
      const convertPdf = {
        orientation: 'p',
        unit: 'pt',
        format: 'a4',
        putOnlyUsedFonts: true,
        compress: true,
        filters: ['ASCIIHexEncode']
      }
      const doc = new JsPdf(convertPdf)
      doc.html(contentHtml, {
        callback: (pdf) => {
          pdf.deletePage(2)
          pdf.save(fileName)
          dpi.remove()
          contentHtml.remove()
          this.loaderRun = false
          this.$emit('close', true)
          const lastRouteContact = _.get(this.$router, 'history.current.name', '')
          if (goBack && lastRouteContact === 'ContactCard') {
            this.$router.push({name: 'ContactsList'})
          }
        },
        x: -60
      })
    },
    beforeCreateInvoice (editMode) {
      const editedExtra = []
      const services = _.cloneDeep(this.servicesChecked)
      services.forEach(item => {
        const calc = this.amount(item)
        item.quantity = item.quantity || 1
        item.discount = +this.discount.number[item.id] || 0
        item.category = (item.serviceType || item.serviceType === 0) ? item.serviceType : item.category
        item.project = item.project ? _.get(item, 'project.id', item.project) : ''
        item.value = calc.amount - calc.extra
        if (item.institution) {
          item.institution = item.institution.id
        }
        if (item.category === 1) {
          const oldService = _.find(this.originalInvoice.services, {id: item.id})
          const oldExtraValue = +_.get(oldService, 'extraValue', '')
          item.extraValue = this.validateNum(item.extraValue) || 0
          editedExtra.push(oldExtraValue === item.extraValue)
        }
      })
      const newAdditionalPay = this.clientTotals.ratio < 0 ? this.additionalPay * -1 : this.additionalPay
      const changeAdditionalPay = this.oldAdditionalPay !== this.additionalPay && this.additionalPay !== 0
      const additionalPay = changeAdditionalPay || !this.addAdditionalPay ? newAdditionalPay : this.oldAdditionalPay
      const invoice = {
        additionalPay: +additionalPay || 0,
        issuedTo: this.issuedToChange,
        user: this.userInfo.id,
        services: _.sortBy(services, ['expirePriority']),
        bankAccount: this.bankDetails.id,
        issueDate: this.dates.issue,
        dueDate: this.dates.due,
        totalInvoicedAed: this.roundNum(this.payment().AED),
        vat: this.roundNum(this.payment().vatAED),
        ibanList: [],
        course: this.payment().course,
        additionalCreditNotePay: this.currentCreditNotes
      }
      if (this.issueProforma) invoice.isSoaProforma = true
      if (editedExtra.some(item => item === false)) {
        invoice.extraModify = true
      }
      if (!editMode) {
        invoice.number = this.generateInvoiceCode()
        invoice.client = this.clientInfo.id
      }
      if (editMode && this.servicesDeleted.length > 0) {
        invoice.transfersDeletedServices = this.servicesDeleted
      }
      _.forEach(this.bankDetailValue, (value, item) => {
        if (value) {
          invoice.ibanList.push(item)
        }
      })
      return invoice
    },
    async createInvoice () {
      this.hideForPdf = true
      const invoice = this.beforeCreateInvoice()
      this.loaderRun = true
      this.maxCreditNotes = false
      const respInvoice = await this.invoiceCreate(invoice)
      if (respInvoice.status === 200) {
        this.loaderRun = false
        this.generatePdf('goBack')
        this.$set(this.clientInfo, 'invoiceCounter', {seq: respInvoice.data.invoiceCounter})
        this.proformaInvoiceSave = true
        this.$emit('updateInvoices')
        if (this.issueProforma) {
          const query = {
            client: this.clientInfo.id,
            invoice: this.invoiceIssueId,
            services: this.servicesChecked.map(item => {
              return {
                value: item.value,
                proformaServiceId: item.proformaServiceId
              }
            })
          }
          SoaApi.createSoaInvoiceProforma(query)
            .then((resp) => {})
            .catch((err) => {
              this.loaderRun = false
              this.$emit('close', true)
              console.error(err)
            })
        }
      }
    },
    async invoiceCreate (query) {
      try {
        const resp = await InvoiceApi.createInvoice(query)
        return resp
      } catch (e) {
        this.loaderRun = false
        this.$emit('close', true)
        console.error(e)
      }
    },
    editInvoices () {
      this.hideForPdf = true
      this.maxCreditNotes = false
      const invoice = this.beforeCreateInvoice('editMode')
      const received = this.editableInvoice.invoice.received
      const total = invoice.totalInvoicedAed
      if (received === 0) {
        invoice.status = 0
      } else if (received > total) {
        invoice.status = 3
      } else if (received < total) {
        invoice.status = 1
      } else {
        invoice.status = 2
      }
      invoice.uploadFile = this.getFilesIds()
      InvoiceApi.editInvoices(invoice, this.editableInvoice.invoice.id)
        .then((resp) => {
          this.generatePdf()
          this.invoicesList.invoices.splice(this.editableInvoice.index, 1, resp.data)
          this.invoicesList.invoices[this.editableInvoice.index].client = this.clientInfo
          this.proformaInvoiceSave = true
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getFilesIds () {
      const files = _.get(this.editableInvoice, 'invoice.uploadFile', [])
      return files.length ? _.map(files, item => item.id) : []
    },
    cancelProforma () {
      this.$emit('close')
    },
    checkboxChange (data, item) {
      this.bankDetailValue[item] = data
    },
    displayAdditionalPay () {
      if (!this.clientInfo || !this.clientTotals) return
      if (this.clientTotals.status === 'overpaid') return
      if (this.editableInvoice) {
        const additionalPreviousDues = _.get(this.editableInvoice, 'invoice.additionalPreviousDues', 0)
        this.additionalPay = additionalPreviousDues
        return additionalPreviousDues > 0
      }
      const additionalPreviousDues = this.clientTotals.previousDues
      this.additionalPay = additionalPreviousDues
      return additionalPreviousDues > 0
    },
    checkboxChangeAdditionalPay (data, item) {
      if (!data) this.additionalPay = 0
      this.addAdditionalPay = data
      this.setMaxAdditionalPay()
      this.checkedMaxValueCreditNote()
    },
    checkboxChangeCreditNote (data, item) {
      this.includeCreditNotes = data
      if (data === false) {
        this.currentCreditNotes = 0
      } else {
        this.currentCreditNotes = this.maxCreditNotes
      }
      this.checkedMaxValueCreditNote()
    },
    setMaxAdditionalPay () {
      const editable = _.get(this.editableInvoice, 'invoice.additionalPay', 0) && !this.changeAdditionalPay
      if (editable || this.viewMode || !this.addAdditionalPay) return
      this.additionalPay = this.clientTotals.ratio < 0 ? this.clientTotals.previousDues : this.clientTotals.ratio
      this.checkedMaxValueAdditionalPay()
    },
    setChangeAdditionalPay () {
      this.setMaxAdditionalPay()
      if (this.viewMode) return
      this.hideForPdf = false
      this.changeAdditionalPay = true
    },
    deleteService (index, id) {
      this.discount = _.cloneDeep(this.discount)
      this.discount.number[id] = 0
      this.discount.status[id] = 0
      this.deleteConfirmIndex = false
      this.$delete(this.servicesChecked, index)
      if (this.servicesChecked.length === 0) {
        this.$set(this.clientInfo, 'selectServices', false)
      }
      const transfer = _.get(this.servicesChecked[index], 'transfer', false)
      if (transfer) this.servicesDeleted.push(...transfer)
      this.setMaxAdditionalPay()
      this.checkedMaxValueCreditNote()
      this.checkedValidateServices()
    },
    checkDiscount (id) {
      if (this.discount.number[id] === 0) {
        return
      }
      this.discount = _.cloneDeep(this.discount)
      this.discount.number[id] = String(this.discount.number[id]).replace(/^0+|[^.\d;]/, '')
      if (!this.discount.number[id] && this.discount.number[id] !== 0) {
        this.discount.number[id] = ''
      }
      if (+this.discount.number[id] > 90) {
        this.discount.number[id] = 90
      }
    },
    changeQuantity (service) {
      service.quantity = +service.quantity.replace(/^0+/, '')
      if (!service.quantity) {
        service.quantity = ''
      }
      if (+service.quantity < 0) {
        service.quantity = Math.abs(+service.quantity)
      }
      const index = _.findIndex(this.servicesChecked, {'id': service.id})
      this.$set(this.servicesChecked, index, service)
    },
    validateNum (num) {
      let trueNumber = num
      if (typeof trueNumber === 'string') {
        trueNumber = +trueNumber.replace(/[-,]/, '')
      }
      return isNaN(trueNumber) ? 0 : trueNumber
    },
    calcValuesService (service, type) {
      const value = this.validateNum(service.value)
      const extraValue = this.validateNum(service.extraValue)
      const sum = this.validateNum(service.originValue)
      if (value > sum) {
        service.extraValue = 0
        service.value = sum
        return
      }
      if (extraValue > sum) {
        service.extraValue = sum
        service.value = 0
        return
      }
      if (type === 'value') {
        service.extraValue = sum - value
      } else {
        service.value = sum - extraValue
      }
    },
    amount (service) {
      const extra = service.extraValue ? this.validateNum(service.extraValue) : 0
      const amount = this.validateNum(service.value) + extra
      const qty = service.quantity
      const discount = this.discount.number[service.id]
      const pureTotal = (amount * qty)
      let vat = service.vat
      let total = pureTotal
      if (discount) {
        total = pureTotal - (pureTotal * discount / 100)
      }
      if (isNaN(service.vat)) {
        vat = 0
      }
      const vatAmount = (total * vat) / 100
      const allTotal = vatAmount + total
      return {
        amount: amount,
        extra: extra,
        vatAmount: vatAmount,
        allTotal: allTotal,
        total: total
      }
    },
    roundNum (num) {
      return Math.round(num * 100) / 100
    },
    subTotal () {
      return this.servicesChecked.reduce((sum, item) => {
        sum += this.amount(item).total
        return sum
      }, 0)
    },
    totalVat () {
      return this.servicesChecked.reduce((sum, item) => {
        sum += this.amount(item).vatAmount
        return sum
      }, 0)
    },
    payment () {
      const vat = this.company.settings ? this.company.settings.vat : 5;
      const usdRate = _.get(this.bankDetails, 'currencyRates.usd', 3.67);
      const eurRate = _.get(this.bankDetails, 'currencyRates.eur', 3.9);
      const rubRate = _.get(this.bankDetails, 'currencyRates.rub', 1);
      const vatAED = this.roundNum(this.totalServicesVat) * this.roundNum(vat) / 100;
      const totalVat = this.totalVat();
      const additionalPay = this.roundNum(this.additionalPay || 0);
      const totalAed = this.roundNum(this.totalServices) + this.roundNum(totalVat);

      let toBePay = totalAed;
      if (this.addAdditionalPay) toBePay = toBePay + additionalPay;
      if (this.includeCreditNotes) toBePay = toBePay - this.currentCreditNotes;

      const received = _.get(this.editableInvoice, ['invoice', 'received'], 0);
      const totalDue = toBePay - received;

      const totalUsd = totalDue / +usdRate;
      const totalEur = totalDue / +eurRate;
      const totalRub = totalDue / +rubRate;

      return {
        vatAED: vatAED,
        AED: this.roundNum(totalAed),
        USD: this.roundNum(totalUsd),
        EUR: this.roundNum(totalEur),
        RUB: this.roundNum(totalRub),
        toBePay: this.roundNum(toBePay),
        course: {
          usd: usdRate,
          euro: eurRate,
          rub: rubRate,
        }
      }
    },
    toggleChange (data, name) {
      if (data === 'hide') {
        return
      }
      if (!data) {
        this.$set(this.discount.number, name.id, 0)
      }
      this.$set(this.discount.status, name.id, data)
    },
    hideServicesList () {
      this.servicesListOpen = false
    },
    addServices (checkedList, setDefault) {
      checkedList.forEach(item => {
        item.includeOfProject = item.includeOfProject !== false
      })
      if (checkedList.length > 0) {
        this.$set(this.clientInfo, 'selectServices', true)
      }
      this.hideServicesList()
      this.servicesChecked = checkedList
      _.forEach(this.servicesChecked, item => {
        if (item.expireCategory) {
          item.displaySelectCompany = this.displayCompanySelect(item)
          item.displaySelectLicense = this.displayLicenseSelect(item)
        }
        item.originValue = item.value
        item.quantity = item.quantity || 1
        if (setDefault) {
          this.setDefaultSelectExpire(item)
        }
      })
      if (!this.maxCreditNotes) {
        this.getNotConsumed(this.clientInfo.id)
      }
      this.setMaxAdditionalPay()
      this.checkedValidateServices()
      this.getTotalCreditNote(this.clientInfo.id)
    },
    getNotConsumed (id) {
      CreditNotesApi.getCreditNotesConsumed(id)
        .then((resp) => {
          this.maxCreditNotes = resp.data.notConsumed
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getTotalCreditNote (id) {
      SoaCreditNote.getTotalCreditNote(id)
        .then(({data}) => {
          this.totalCreditNotes = data.total
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setListsForServices () {
      _.forEach(this.servicesChecked, service => {
        if (service.expireCategory) {
          const list = this.getListForLicense(service) || []
          this.$set(service, 'licenseList', list)
        }
      })
      this.checkedValidateServices()
    },
    addService () {
      this.servicesListOpen = true
    },
    setCategory (item) {
      this.category = item
    },
    setBankDetails (item) {
      if (!item) {
        return
      }
      this.bankDetailValue.EUR = false
      this.bankDetailValue.USD = false
      this.bankDetailValue.AED = true
      this.bankDetails = item
      if (this.editableInvoice && !this.editBankSet) {
        this.editBankSet = true
        const bankAccount = _.get(this.editableInvoice, 'invoice.bankAccount', item)
        this.bankDetails = bankAccount
        const ibanList = _.get(this.editableInvoice, 'invoice.ibanList', [])
        ibanList.forEach(iban => {
          if (iban) {
            this.$set(this.bankDetailValue, iban, true)
          }
        })
      }
    },
    setSevenDays (date) {
      return new Date(moment(date).add(7, 'day').format())
    },
    setIssueDate (date) {
      this.$set(this.dates, 'issue', date)
      this.$set(this.dates, 'due', this.setSevenDays(date))
    },
    setDueDate (date) {
      this.$set(this.dates, 'due', date)
    },
    getInvoicesTotal () {
      const additionalPay = _.get(this.editableInvoice, 'invoice.additionalPay', 0)
      const clientID = _.get(this.clientInfo, 'id', '')
      const query = 'isDelete[]=false&client[]=' + clientID
      InvoiceApi.getInvoicesTotal({query})
        .then((resp) => {
          const overpaid = _.get(resp.data, 'totalOverpaid', 0)
          const underpaid = _.get(resp.data, 'totalUnderpaid', 0)
          const previousDues = _.get(resp.data, 'previousDues', 0)
          const ratio = this.roundNum(overpaid - previousDues)
          const overpaidInvoices = _.get(resp.data, 'overpaidInvoices', [])
          this.clientTotals = _.cloneDeep(this.clientTotals)
          this.clientTotals = {
            overpaid: overpaid,
            underpaid: underpaid,
            ratio: ratio,
            overpaidInvoices: overpaidInvoices,
            previousDues: previousDues
          }
          this.clientTotals.status = this.setStatusBalance(ratio)
          const differentSignNumber = (ratio > 0 && additionalPay < 0) || (ratio < 0 && additionalPay > 0)
          this.hideForPdf = this.viewMode
          if (differentSignNumber) {
            this.hideForPdf = additionalPay !== 0 || this.viewMode
            this.oldAdditionalPay = additionalPay
            this.additionalPay = 0
          }
          this.setMaxAdditionalPay()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getClient () {
      const clientId = _.get(this.editableInvoice, 'client.id', '')
      if (!clientId) {
        this.clientInfo = {}
        return
      }
      ContactsApi.getContact(clientId)
        .then((resp) => {
          this.clientInfo = resp.data
          this.getInvoicesTotal()
        })
        .catch((err) => {
          this.clientInfo = {}
          console.error(err)
        })
    },
    getCategories () {
      this.serviceCategories = this.serviceCategoriesList
    },
    getCompany () {
      if (!this.activeCompany) {
        return
      }
      CompaniesApi.getCompaniesById(this.activeCompany)
        .then((resp) => {
          this.company = resp.data
          this.$emit('setVat', this.company.settings)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getBankDetails () {
      bankDetailsApi.getBankDetails()
        .then((resp) => {
          this.bankDetailsList = resp.data.bankDetails
          if (this.bankDetailsList.length === 0) {
            this.$set(this.clientInfo, 'hasBankDetails', false)
          } else {
            this.$set(this.clientInfo, 'hasBankDetails', true)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getUser: function () {
      userApi.getUser()
        .then((resp) => {
          this.userInfo = resp.data
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setServicesForEditable () {
      const checkedServices = _.map(this.editableInvoice.invoice.services, item => {
        item.serviceType = item.category
        item.originValue = +item.value + +item.extraValue
        if (item.discount > 0) {
          this.discount = _.cloneDeep(this.discount)
          this.discount.status[item.id] = true
          this.discount.number[item.id] = item.discount
        }
        return item
      })
      if (checkedServices.length > 0) {
        this.addServices(checkedServices, true)
      }
    },
    setIssuedToIndividual () {
      const editable = this.editableInvoice
      const target = this.editableInvoice || this.clientInfo
      const firstNameProp = editable ? 'invoice.client.firstName' : 'firstName'
      const firstName = _.get(target, firstNameProp, '')
      const lastNameProp = editable ? 'invoice.client.lastName' : 'lastName'
      const lastName = _.get(target, lastNameProp, '')
      const addressProp = editable ? 'invoice.client.address' : 'address'
      const address = _.get(target, addressProp, '')
      const issuedTo = _.get(this.editableInvoice, 'invoice.issuedTo', '')
      const issued = issuedTo && issuedTo !== 'false'
      this.issuedTo = issued ? issuedTo : `${firstName} ${lastName} ${address}`
    },
    setIssuedToEntity () {
      const editable = this.editableInvoice
      const target = this.editableInvoice || this.clientInfo
      const companyProp = editable ? 'invoice.client.clientCompany' : 'clientCompany'
      const clientCompany = _.get(target, companyProp, '')
      const detailsProp = editable ? 'invoice.client.clientCompanyDetails' : 'clientCompanyDetails'
      const clientCompanyDetails = _.get(target, detailsProp, '')
      const issuedTo = _.get(this.editableInvoice, 'invoice.issuedTo', '')
      const issued = issuedTo && issuedTo !== 'false'
      this.issuedTo = issued ? issuedTo : `${clientCompany} ${clientCompanyDetails}`
    },
    setIssuedTo () {
      const editable = this.editableInvoice
      const target = this.editableInvoice || this.clientInfo
      const typePropClient = this.clientInfo.invoiceType ? 'invoiceType' : 'clientType'
      const typeProp = editable ? `invoice.client.${typePropClient}` : typePropClient
      const invoiceType = +_.get(target, typeProp, '')
      const individual = invoiceType === 1
      const entity = invoiceType === 2
      if (individual) {
        this.setIssuedToIndividual()
      } else if (entity) {
        this.setIssuedToEntity()
      } else {
        this.issuedTo = _.get(this.editableInvoice, 'invoice.issuedTo', '')
      }
      this.issuedToChange = this.issuedTo
    },
    setStatusBalance (ratio) {
      if (ratio > 0) {
        return 'overpaid'
      } else if (ratio < 0) {
        return 'underpaid'
      } else {
        return ''
      }
    },
    getLabelExpireSelect (expireCategory) {
      const category = _.find(expireCategoriesForServiceForm, {id: expireCategory})
      return _.get(category, 'name', 'License')
    },
    displayCompanySelect (service) {
      const expireCategoryId = service.expireCategory
      const display = expireCategoryId && expireCategoryId !== APARTMENT_LEASE_EXPIRY.id
      if (!display) {
        this.getApartments()
      }
      return display
    },
    displayLicenseSelect (service) {
      const expireCategoryId = service.expireCategory
      const idsDisplaySelect = [LICENSE_EXPIRY.id, APARTMENT_LEASE_EXPIRY.id, VISA_EXPIRY.id]
      return idsDisplaySelect.includes(expireCategoryId)
    },
    getListForLicense (service) {
      const expireCategoryId = service.expireCategory
      let list
      switch (expireCategoryId) {
      case LICENSE_EXPIRY.id:
        const licenses = _.get(this.companyLicenses, service.clientCompany, [])
        list = licenses.map(item => {
          item.name = item.licenseNo
          return item
        })
        break
      case APARTMENT_LEASE_EXPIRY.id:
        const address = this.clientAddress || []
        list = address.map(item => {
          item.name = item.address
          return item
        })
        break
      case VISA_EXPIRY.id:
        const visas = _.get(this.companyVisas, service.clientCompany, [])
        list = visas.map(item => {
          item.name = item.visaOwnerName
          return item
        })
        break
      }
      return list || []
    },
    setClientCompany (val, item) {
      const expireCategoryId = item.expireCategory
      const idsForInCompany = [ECHANNEL_EXPIRY.id, CARD_EXPIRY.id, OFFICE_LEASE_EXPIRY.id]
      const inCompany = idsForInCompany.includes(expireCategoryId)
      item.clientCompany = val.id
      this.$set(item, 'expireInstanceId', '')
      if (expireCategoryId === LICENSE_EXPIRY.id) {
        this.getLicenses(val.id)
      } else if (expireCategoryId === VISA_EXPIRY.id) {
        this.getVisas(val.id)
      } else if (inCompany) {
        this.$set(item, 'expireInstanceId', val.id)
      }
      this.checkedValidateServices()
    },
    setClientLicense (val, item) {
      if (val.id) {
        this.$set(item, 'expireInstanceId', val.id)
      } else {
        this.$set(item, 'expireInstanceId', '')
      }
      this.checkedValidateServices()
    },
    checkedValidateServices () {
      const idsExpire = []
      this.servicesChecked.forEach(service => {
        const expireCategory = _.find(expireCategoriesForServiceForm, {id: service.expireCategory})
        service.expirePriority = _.get(expireCategory, 'priority', 99)
        if (service.expireCategory) {
          idsExpire.push(service.expireInstanceId)
        }
      })
      const hasNoIdExpire = idsExpire.some(item => !item);
      this.$set(this.clientInfo, 'expireValidate', !hasNoIdExpire || idsExpire.length === 0)
    },
    setDefaultSelectExpire (service) {
      const expireCategory = _.get(service, 'expireCategory', '')
      const idsForInCompany = [ECHANNEL_EXPIRY.id, CARD_EXPIRY.id, OFFICE_LEASE_EXPIRY.id]
      if (idsForInCompany.includes(expireCategory)) {
        const result = _.find(this.clientCompanies, {id: service.expireInstanceId}) || this.clientCompanies[0]
        service.defaultCompany = result
      } else if (expireCategory === LICENSE_EXPIRY.id) {
        this.getLicenseById(service.expireInstanceId, service)
      } else if (expireCategory === VISA_EXPIRY.id) {
        this.getVisaById(service.expireInstanceId, service)
      } else if (expireCategory === APARTMENT_LEASE_EXPIRY.id) {
        this.getApartmentById(service.expireInstanceId, service)
      }
    },
    getLicenseById (id, service) {
      ContactsLicenseApi.getContactLicenseById(id)
        .then((resp) => {
          const name = _.get(resp, 'data.licenseNo', '')
          const companyId = _.get(resp, 'data.clientCompany.id', '')
          resp.data.name = name
          service.defaultLicense = resp.data
          service.defaultCompany = _.find(this.clientCompanies, {id: companyId}) || this.clientCompanies[0]
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getVisaById (id, service) {
      ContactCompanyVisasApi.getVisaById(id)
        .then((resp) => {
          const name = _.get(resp, 'data.visaOwnerName', '')
          const companyId = _.get(resp, 'data.clientCompany.id', '')
          resp.data.name = name
          service.defaultLicense = resp.data
          service.defaultCompany = _.find(this.clientCompanies, {id: companyId}) || this.clientCompanies[0]
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getApartmentById (id, service) {
      ContactsAddressApi.getContactAddressById(id)
        .then((resp) => {
          const name = _.get(resp, 'data.address', '')
          resp.data.name = name
          service.defaultLicense = resp.data
        })
        .catch((e) => {
          console.error(e)
        })
    },
    getContactCompanies () {
      this.loaderRun = true
      ContactCompanyApi.getContactCompanies({limit: 500, client: this.clientInfo.id})
        .then((resp) => {
          this.loaderRun = false
          this.clientCompanies = resp.data.clientcompanies
          if (this.editableInvoice) {
            this.setServicesForEditable()
          }
        })
        .catch((e) => {
          this.loaderRun = false
          console.error(e)
        })
    },
    getLicenses (clientCompanyId) {
      this.loaderRun = true
      const licensesReady = _.get(this.companyLicenses, clientCompanyId, [])
      if (licensesReady.length > 0) {
        this.loaderRun = false
        this.setListsForServices()
        return
      }
      const sort = 'licenseDate'
      ContactsLicenseApi.getContactLicense({limit: 500, sort, clientCompany: clientCompanyId})
        .then((resp) => {
          this.loaderRun = false
          const licenses = _.filter(resp.data.clientcompanylicenses, item => item)
          _.set(this.companyLicenses, clientCompanyId, licenses)
          this.setListsForServices()
        })
        .catch((e) => {
          this.loaderRun = false
          console.error(e)
        })
    },
    getApartments () {
      this.loaderRun = true
      const sort = 'leaseExpDate&sort[]=-1'
      if (this.clientAddress.length > 0) {
        this.loaderRun = false
        this.setListsForServices()
        return
      }
      ContactsAddressApi.getContactAddress({limit: 500, sort, client: this.clientInfo.id})
        .then((resp) => {
          this.loaderRun = false
          this.clientAddress = _.filter(resp.data.clientresidentialaddresses, item => item)
          this.setListsForServices()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getVisas (clientCompanyId) {
      this.loaderRun = true
      const visasReady = _.get(this.companyVisas, clientCompanyId, [])
      if (visasReady.length > 0) {
        this.loaderRun = false
        this.setListsForServices()
        return
      }
      const sort = 'sort[]=visaExpDate'
      ContactCompanyVisasApi.getVisas({limit: 500, sort, clientCompany: clientCompanyId})
        .then((resp) => {
          this.loaderRun = false
          const visas = _.filter(resp.data.clientcompanyvisas, item => item)
          _.set(this.companyVisas, clientCompanyId, visas)
          this.setListsForServices()
        })
        .catch((e) => {
          this.loaderRun = false
          console.error(e)
        })
    },
    keyupEvent (event) {
      if (event.keyCode === 27) {
        this.hideServicesList()
      }
    }
  },
  watch: {
    activeCompany: function () {
      this.getCompany()
    },
    bankDetailsList () {
      if (this.bankDetailsList.length > 0) {
        this.bankDetails = this.bankDetailsList[0]
      }
    }
  },
  updated () {
    if (this.$refs.ServicesList) {
      this.addServicesCheckList = this.$refs.ServicesList.addServicesCheckList
    }
  },
  mounted () {
    if (this.editableInvoice) {
      const { invoice = {} } = this.editableInvoice
      const { issueDate, dueDate } = invoice
      this.dates = {
        issue: new Date(issueDate),
        due: new Date(dueDate)
      }
    }
    document.addEventListener('keyup', this.keyupEvent)
    if (this.bankDetailsList.length === 0) {
      this.$set(this.clientInfo, 'hasBankDetails', false)
    } else {
      this.$set(this.clientInfo, 'hasBankDetails', true)
    }
    if (this.viewMode) {
      this.activeViewMode()
    }
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.keyupEvent)
    this.$set(this.clientInfo, 'selectServices', false)
  },
  beforeMount () {
    this.getCompany()
    this.setIssuedTo()
    if (this.editableInvoice) {
      const additionalPay = _.get(this.editableInvoice, 'invoice.additionalPay', 0)
      const currentCreditNotes = _.get(this.editableInvoice, 'invoice.additionalCreditNotePay', 0)
      const additionalPreviousDues = _.get(this.editableInvoice, 'invoice.additionalPreviousDues', 0)
      this.currentCreditNotes = currentCreditNotes
      this.includeCreditNotes = currentCreditNotes
      this.oldClientStatus = this.setStatusBalance(additionalPay)
      this.clientTotals.status = this.setStatusBalance(additionalPay)
      this.additionalPay = additionalPreviousDues
      if (this.additionalPay !== 0) this.addAdditionalPay = true
      this.originalInvoice = _.cloneDeep(this.editableInvoice.invoice)
      this.clientInfo = this.editableInvoice.invoice.client
    }
    this.getContactCompanies()
    if (!this.clientInfo.id) {
      this.getClient()
    } else if (!this.viewMode) {
      this.getInvoicesTotal()
    } else {
      this.hideForPdf = this.viewMode
    }
    if (this.serviceCategories.length === 0) {
      this.getCategories()
    }
    if (this.bankDetailsList.length === 0) {
      this.getBankDetails()
    }
    if (!this.userInfo.id) {
      this.getUser()
    }
    if (this.issueProforma) {
      this.issueProformaServices.forEach((item, index) => {
        item.parentIssueProforma = item._id
        item.quantity = item.quantity || 1
        this.$set(this.servicesChecked, index, item)
      })
      this.$set(this.clientInfo, 'selectServices', true)
      this.extraValueEdit = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";
@import "../../../../../../sass/mixins";

.bb-proforma-wrapper {
  margin: auto;
  min-width: 100%;

}

.bb-proforma {
  @include global-font;
  background: $color-white;
  border-radius: 5px;
  min-width: 700px;

  &_type2 {
    .bb-proforma__text-accent,  {
      color: $color-gray;
    }

    .bb-proforma-bank-name__reference {
      border-bottom-color: $color-gray;
    }

    .bb-proforma-total-calculations__row_accent {
      color: $color-black;
    }

  }

  &__space {
    margin: 0 0 0 5px;
  }

  &-header {
    margin-bottom: 16px;

    &-title-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;

      &__logo {
        margin-right: 13px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
      }

      &__title {
        font-size: 45px;
        font-weight: 600;
        line-height: 53px;

      }
    }

    &__note {
      margin-top: 6px;
      text-align: center;
      font-size: 13px;
      line-height: 15px;
    }
  }

  &-details {
    display: flex;

    &-section {
      display: flex;
      flex-direction: column;
      position: relative;
      width: 100%;
      margin: 0 -1px;

      &__header {
        display: flex;
        align-items: center;
        background: $color-guardsman-red;
        height: 38px;
        color: $color-white;
        font-size: 14px;
        line-height: 17px;
        font-weight: 500;
        padding-left: 17px;
        margin-bottom: 13px;
        white-space: nowrap;

        &_type2 {
          background: $color-black;
        }

        &_first {
          border-radius: 5px 0 0 5px;
        }

        &_last {
          border-radius: 0 5px 5px 0;
        }
      }

      &__header-invoice {
        margin: 0 0 0 10px;
      }

      &_date {
        margin-top: auto;
      }

      &-item {
        padding-left: 17px;
        display: flex;
        font-size: 13px;
        line-height: 17px;
        margin-bottom: 11px;
        z-index: 12;

        &_event {
          pointer-events: none;
        }

        &_ref {
          margin-bottom: 15px;
          min-height: 50px;
        }

        &__title {
          min-width: 110px;
          font-weight: 700;

          &_center {
            align-self: center;
          }
        }

        &-client-info {
          position: relative;
          width: 100%;

          &__edit {
            position: absolute;
            left: 81%;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            font-size: 10px;
            width: 21px;
            height: 21px;
            cursor: pointer;
            user-select: none;
          }

          &__name {
            width: 80%;
            max-width: 325px;
            margin-bottom: 7px;
            height: auto;
            line-height: 26px;
            border: 1px solid transparent;

            &_border {
              border: 1px solid $color-wild-sand;
              box-sizing: border-box;
              border-radius: 5px;
            }

            pre {
              white-space: pre-line;
              line-height: 17px;
            }
          }
        }
      }
    }
  }

  &-services {
    display: flex;

    &-section {
      position: relative;
      display: flex;
      flex-direction: column;
      max-width: 100%;
      margin: 0 -1px;

      &_amount {
        min-width: 140px;
      }

      &-extra {
        display: flex;
        align-items: center;

        &__icon {
          position: absolute;
          left: 0;
          margin-right: 10px;
          width: 21px;
          height: 21px;
          cursor: pointer;
        }

        &-item {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          &-wrapper {
            display: flex;
          }

          &_first {
            margin-right: 10px;
          }

          &__title {
            position: absolute;
            top: -15px;
            font-size: 10px;
            color: $color-dusty-gray;
          }
        }
      }

      &_number {
        flex-basis: 30px;
      }

      &_service {
        flex-grow: 3;
      }

      &_qty {
        flex-basis: 40px;
      }

      &__header {
        display: flex;
        align-items: center;
        background: $color-guardsman-red;
        min-height: 38px;
        color: $color-white;
        font-size: 14px;
        line-height: 16px;
        font-weight: 500;
        margin-bottom: 5px;
        padding-left: 17px;
        padding-right: 2px;
        text-align: center;
        white-space: nowrap;

        &_center {
          justify-content: center;
        }

        &_service {
          white-space: nowrap;
        }

        &_first {
          padding-left: 17px;
          border-radius: 5px 0 0 5px;
          font-size: 11px;
        }

        &_last {
          padding-right: 17px;
          border-radius: 0 5px 5px 0;
        }
      }

      &-item {
        flex-grow: 1;
        padding-left: 17px;
        display: flex;
        align-items: center;
        font-size: 13px;
        line-height: 16px;
        padding-top: 10px;
        padding-bottom: 10px;
        min-height: 22px;
        height: 100%;
        border-bottom: 1px solid $color-wild-sand;

        &_extra {
          margin: 7px 0;
          transition: .2s linear;
        }

        &:last-child {
          border-bottom: none;
        }

        &_service {
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &_bold {
          font-weight: bold;
        }

        &_center {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 9px;
        }

        &-discount {
          display: flex;
          align-items: center;
          min-height: 19px;
          margin-right: 22px;
          min-width: 106px;

          i {
            color: $color-silver
          }

          &__input {
            text-align: center;
            width: 30px;
            height: 24px;
            border: 1px solid $color-wild-sand;
            box-sizing: border-box;
            border-radius: 2px;
            margin: 0 10px;
          }

          &__delete {
            position: absolute;
            right: 0;
            width: 20px;
            height: 20px;
            cursor: pointer;
          }
        }

        &__input {
          font-family: $global-font;
          text-align: center;
          width: 40px;
          height: 24px;
          border: 1px solid $color-wild-sand;
          box-sizing: border-box;
          border-radius: 2px;

          &_text {
            position: absolute;
          }
        }

        &__title {
          min-width: 110px;
          font-weight: 700;

          &_center {
            align-self: center;
          }
        }
      }
    }
  }

  &-service-list {
    &-row {
      display: grid;
      grid-template-columns: 10px 244px 21px 67px 41px 73px 84px 48px 61px 64px 21px;
      grid-gap: 17px;
      align-items: center;
      justify-content: space-between;
      padding: 8px 17px;
      font-size: 13px;
      line-height: 14px;

      &_without-discount {
        grid-template-columns: 10px 270px 21px 70px 30px 70px 55px 61px 60px 21px
      }

      &_expire {
        grid-template-rows: 1fr 1fr;
        grid-gap: 6px 17px;
      }

      &_header {
        padding: 12px 17px;
        color: $color-white;
        font-size: 14px;
        line-height: 16px;
        font-weight: 500;
        background: $color-guardsman-red;
        border-radius: 5px;
        margin-bottom: 10px;

        &.bb-proforma-service-list-row_type2 {
          background: $color-black;
        }

      }

      &__center {
        display: inline-flex;
        justify-content: center;
        text-align: center;

        &_hide {
          display: none;
        }
      }

      &__extra-icon {
        width: 21px;
        height: 21px;
        font-size: 21px;
      }

      &__amount {
        position: relative;
      }

      &-extra {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;

        &-item {
          position: relative;
          display: grid;
          align-items: center;
          justify-content: center;

          &__title {
            position: absolute;
            top: -15px;
            left: 0;
            width: 100%;
            font-size: 10px;
            color: $color-dusty-gray;
            text-align: center;
          }
        }
      }

      &__index {
        font-weight: 500;
      }

      &__name {
        word-break: break-word;
      }

      &-expire {
        display: grid;
        align-items: center;
        grid-template-columns: auto 1fr;
        grid-template-rows: 1fr;
        grid-gap: 6px;
        height: 32px;
        width: 100%;
        max-width: 350px;
        margin-right: 17px;

        &_include {
          grid-template-columns: 150px 14px;
          user-select: none;
          cursor: pointer;
        }

        &__checkbox {
          pointer-events: none;
        }

        &-container {
          grid-column: 2/9;
          display: flex;
          align-items: center;
          justify-content: start;
        }

        &__label {
          font-weight: 500;
          line-height: 14px;
          transition: 0.3s;

          &_include {
            &:hover {
              opacity: 0.7;
            }
          }
        }

        &__no-entries {
          color: $color-guardsman-red;
        }
      }

      &__input {
        display: block;
        width: 100%;
        box-sizing: border-box;
        border-radius: 2px;
        padding: 3px 6px;
        border: 1px solid $color-wild-sand;

        &:disabled {
          border-color: transparent;
        }

        &_center {
          text-align: center;
          background-color: transparent;
          color: $color-black;
        }
      }

      &-discount {
        display: grid;
        grid-template-columns: 21px 30px 10px;
        align-items: center;
        grid-gap: 5px;

        &__icon {
          color: $color-silver;
          font-size: 13px;
        }
      }

      &_pdf {
        grid-template-columns: 15px 160px 50px 20px 66px 37px 45px 37px 52px;
        font-size: 10px;

        &__input {
          border-color: transparent;
        }
      }

      &_pdf-without-discount {
        grid-template-columns: 15px 160px 50px 20px 60px 27px 47px 41px;
        font-size: 10px;

        &__input {
          border-color: transparent;
        }
      }
    }
  }

  &-total {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;

    &-terms {
      max-width: 275px;
      font-size: 13px;
      line-height: 15px;

      &__title {
        margin-bottom: 5px;
        font-size: 14px;
        line-height: 18px;
      }
    }

    &-calculations {
      display: flex;
      flex-direction: column;
      width: 325px;
      min-height: 169px;
      padding: 14px 20px;
      margin-left: 12px;
      box-sizing: border-box;
      border-radius: 6px;

      &__totals {
        border: 1px solid $color-wild-sand;
        padding: 14px 20px;
        margin: 0 -20px;
        box-sizing: border-box;
        border-radius: 6px;
      }

      &__row {
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        font-weight: 700;
        line-height: 16px;
        margin-bottom: 10px;

        &_additional {
          min-height: 24px;
        }

        &_available {
          color: $color-japanese-laurel;
          min-height: 24px;
        }

        &_view {
          cursor: pointer;

          &:hover {
            opacity: 0.6;
          }
        }

        &_old {
          opacity: 0.5;
        }

        &_accent {
          color: $color-guardsman-red;
        }

        &__applied {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: -8px;
          height: 24px;

          &_old {
            height: auto;
          }

          &_input {
            @include global-font;
            margin-left: 5px;
            font-size: 13px;
            height: 100%;
            max-width: 68px;
            text-align: center;
            padding: 5px 4px;
          }
        }

        &_overpaid {
          color: $color-japanese-laurel;
        }

        &_underpaid {
          color: $color-pomegranate;
        }

        &:last-child {
          margin-bottom: 0;
        }

        &_vat {
          font-size: 13px;
          font-weight: normal;
          line-height: 15px;
        }

        &_total {
          margin-bottom: 8px;
        }
      }

      &-dues {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &__right {
          padding-right: 10px;
        }
      }
    }
  }

  &-bank {
    &-name {
      margin-top: 17px;
      text-align: center;
      font-size: 13px;
      font-weight: 600;
      line-height: 17px;

      &__reference {
        border-bottom: 1px solid $color-crimson;
      }
    }

    &-details {
      margin-top: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 30px;

      &__title {
        font-size: 13px;
        font-weight: 700;
        line-height: 17px;

        &_save {
          margin: 14px auto 12px;
        }
      }

      &__select {
        margin-left: 14px;
        margin-right: 27px;
        color: $color-crimson;
        min-width: 170px;
        font-size: 13px;
        height: 30px;
        flex-grow: 0.5;

        &_type2 {
          color: $color-black;
        }

      }

      &-checkboxes {
        display: flex;
        align-items: center;
        width: 170px;
        user-select: none;

        &__checkbox {
          margin-right: 16px;

          &_payments {
            margin-right: 8px;
          }
        }
      }
    }

    &-card {
      width: 415px;
      background: $color-white;
      box-shadow: 0 0 25px rgba($color-black, 0.06);
      border-radius: 5px;
      margin: 15px auto 22px;
      padding: 17px;
      font-size: 14px;
      font-weight: 600;
      line-height: 17px;
      text-align: center;

      &__item {
        margin-bottom: 8px;

        pre {
          white-space: pre-line;
        }

        &_iban {
          font-size: 13px;
        }
      }
    }
  }

  &-footer {
    width: 100%;
    font-size: 13px;
    line-height: 15px;
    text-align: center;

    &__row {
      margin-bottom: 18px;
    }
  }

  &__text-accent {
    color: $color-crimson;
  }

  &__header-invoice {
    color: $color-guardsman-red;

    &_type2 {
      color: $color-gray;
    }

  }

  &-wrapper-service-table {
    max-width: 1500px;
    max-height: 60vh;
    background: $color-white;
    box-shadow: 0 0 20px rgba($color-white, 0.05);
    border-radius: 5px;

    &__button {
      margin-top: 31px;
      margin-left: auto;
      width: 73px;
      margin-right: 8px;
    }
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    line-height: 17px;
    color: $color-guardsman-red;
    border: 1px dashed $color-guardsman-red;
    box-sizing: border-box;
    border-radius: 5px;
    width: 100%;
    height: 34px;
    margin-top: 13px;
    cursor: pointer;
    transition: .15s;

    &_type2 {
      color: $color-denim;
      border-color: $color-denim;
    }

    i {
      display: inline-block;
      transform: rotate(45deg);
    }
  }

  &_hide {
    .bb-proforma {

      &__space {

        &_min {
          margin: 0 0 0 3px;
        }
      }

      &__header-invoice {
        margin: 0 0 0 10px;
      }

      &-header {
        &__note {
          font-size: 11px;
        }

        &-title-wrapper__logo {
          width: 38px;
          height: 38px;
          margin-right: 8px;
        }

        &-title-wrapper__title {
          font-size: 28px;
        }
      }

      &-details {
        &-section-item-client-info__name_border {
          border: 1px solid transparent;
        }

        &-section-item-client-info__edit {
          display: none;
        }

        &-section {
          &-item {
            font-size: 10px;

            &_ref {
              margin-bottom: -20px;
            }
          }
        }
      }

      &-total {
        &-terms {
          max-width: 269px;
          font-size: 10px;
          word-spacing: 1px;

          &__title {
            font-size: 10px;
          }
        }

        &-calculations {
          &__row {
            font-size: 10px;
            word-spacing: 2px;

            &_hide {
              display: none;
            }
          }
        }
      }

      &-bank {
        &-name {
          font-size: 10px;
        }

        &-details {
          &__title {
            font-size: 10px;
            word-spacing: 2px;
          }
        }

        &-card {
          margin-top: 9px;
          font-size: 10px;

          &__item {
            &_iban {
              font-size: 10px;
            }

            pre {
              word-spacing: 2px;
            }
          }
        }
      }

      &-footer {
        font-size: 11px;

        &__row {
          margin-bottom: 10px;
        }
      }

      &-details-section__header,
      &-services-section__header {
        font-size: 10px;

        i {
          font-size: 10px;
        }
      }

      &-services-section-extra__icon {
        display: none;
      }

      &-services-section_total {
        div {
          padding-right: 17px;
          border-radius: 0 5px 5px 0;
        }
      }

      &-services-section-item__input {
        border: none;

        &:disabled {
          font: inherit;
          color: inherit;
          background-color: transparent;
        }
      }

      &-bank-details-checkboxes,
      &-bank-details__select,
      &-services-section_discount,
      &__button {
        display: none;
      }
    }

    .bb-proforma-details-section-item-client-info {
      word-spacing: 3px;
    }

    .bb-proforma-service-list-row {

      &__name {
        word-spacing: 2px;
      }
    }
  }
}



</style>

<style lang="scss">
@import "../../../../../../sass/variables";
.bb-proforma_hide {
  .bb-data-picker {
    &__date {
      font-size: 10px !important;
    }
  }

  .bb-data-picker__icon {
    display: none !important;
  }
}

.bb-proforma {
  &_type2 {
    .bb-toggle__checkbox:checked + span {
      background-color: $color-accent!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ProformaInvoice/ProformaInvoice.vue